//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/TaggedObject.js";
import "../Motion/Motion.SelectLink.js";
import "../no/ugmath.js";
import "../no/SelectObject.js";
let d=[[[0,"Csys",1,"CoordinateSystem",0],[0,"CsysOvrCtrl",1,0],[1,"Link",0,"Motion.SelectLink",0],[0,"LinkOvrCtrl",1,0],[0,"OrientationType",1,0],[0,"OrientationTypeOvrCtrl",1,0],[0,"Origin",1,"Point",0],[0,"OriginOvrCtrl",1,0],[0,"Vector",1,"Direction",0],[0,"VectorOvrCtrl",1,0]],[[[],"GetOrientation",{R_:{orientation:''}},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Motion.LinkAttachmentData = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.LinkAttachmentData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.LinkAttachmentData.OrientationTypes = Object.freeze({
    "None" : "None", "Vector" : "Vector", "Csys" : "Csys"});

export default SPLM;